
import React, {FC} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';

import ErrorIcon from './svgs/error.inline.svg';

import * as styles from './styles.module.scss';

type ReloadErrorProps = {
	className?: string
	children?: React.ReactNode
	fullPage?: boolean
	iframe?: boolean
}

export const ReloadError: FC<ReloadErrorProps> = ({
	className,
	children,
	fullPage,
	iframe,
}) => (
	<div className={classNames({
		[styles.error]: true,
		[styles.fullPage]: fullPage,
		[styles.iframe]: iframe,
		[className || '']: Boolean(className),
	})}>
		<ErrorIcon />
		<h2>Error</h2>
		<span>
			{children || (
				<>
					Something went wrong.
					Please refresh the page and try again.
				</>
			)}
		</span>
		<Button variant='primary' onClick={() => window.location.reload()}>
			Refresh page
		</Button>
	</div>
);
